<script>
import OrganizationBasicInfo from '@/fcl/components/user/OrganizationBasicInfo'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-organization-detail',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'organization-basic-info': OrganizationBasicInfo,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            organization: {
                id: null,
                name: null,
                logoUrl: null,
                area: null,
                contact: null,
                position: null,
                authStatus: null,
                sportTypeLabelList: null,
            },
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onOrganizationEdit() {
           this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'UserOrgEditOrganization',
                    params: { id: this.organization.id }
                }
            })
        },
    },
}
</script>

<template>
    <div class="organization-detail">
        <organization-basic-info 
            :organization="organization"
            @edit-organization="onOrganizationEdit"
        />
    </div>
</template>